<!--
 * @Author: HANG ZHANG
 * @Date: 2020-06-04 20:07:16
 * @Description: 
 * @LastEditors: enmingl
 * @LastEditTime: 2020-11-18 16:16:58
 * @FilePath: /vision-h5/src/modules/modal/ModalWrapper.vue
-->
<template>
	<transition name="modal-shade-fade" @after-leave="onAfterLeave">
		<!-- @touchmove.prevent -->
		<div class="shade" :style="{ zIndex: zIndex }" v-show="isOpenModal">
			<transition name="modal-fade">
				<div v-show="isOpenModal">
					<div class="container">
						<div class="close" @click="close" v-if="closeIcon">
							<!-- <Icon name="kyclose" color="rgba(255, 255, 255, .65)" size="52"></Icon> -->
							<img src="../../images/task/ky-close.png" alt="" />
						</div>
						<slot></slot>
					</div>
				</div>
			</transition>
		</div>
	</transition>
</template>

<script>
	import { trackClick } from '../../lib/track';
	export default {
		name: 'modal-wrapper',
		props: {
			closeIcon: {
				type: Boolean,
				default: true,
			},
			zIndex: {
				type: Number,
				default: 999,
			},
			instanceList: {
				type: Array,
				default: () => [],
			},
		},
		data() {
			return {
				isOpenModal: false, //是否打开模态框
				childThis: null,
				scrollTop: 0,
			};
		},
		computed: {},
		watch: {},
		created() {},
		mounted() {},
		methods: {
			/**
			 * @description: 打弹窗
			 * @param {type}
			 * @return:void
			 */
			show(childThis) {
				this.isOpenModal = true;
				if (childThis) {
					this.childThis = childThis;
				}
				this.afterOpen();
			},
			/**
			 * @description: 关闭弹窗
			 * @param {closeTem} 需要关闭的实例对象
			 * @return:void
			 */
			close() {
				this.beforeClose();
				this.isOpenModal = false;
				this.$emit('onClose');
				// this.$parent.close();
				// // 回调自定义关闭事件
				// if (this.onClose && typeof this.onClose === 'function') {
				// 	this.onClose();
				// }
			},
			closeModal() {
				this.beforeClose();
				this.isOpenModal = false;
			},
			/**
			 * @description: 动画结束，销毁组件
			 * @param {}
			 * @return:viod
			 */
			onAfterLeave() {
				this.destroyElement();
			},
			/**
			 * @description: 销毁组件
			 * @param {type}
			 * @return:viod
			 */
			destroyElement() {
				// 手动销毁挂载dom
				this.childThis.$destroy(true);
				this.childThis.$el.parentNode.removeChild(this.childThis.$el);
			},
			/**
			 * @description: 保持弹窗内的滚动可以进行
			 * @param {}
			 * @return:viod
			 */
			afterOpen() {
				this.scrollTop = this.pageScrollTop();
				if (!document.body.classList) {
					trackClick({
						page_tile: 'ModalWrapper',
						element_name: 'afterOpen-不存在classList',
					});
				}
				if (!document.body.classList.add) {
					trackClick({
						page_title: 'ModalWrapper',
						element_name: 'afterOpen-不存在add方法',
					});
				}
				document.body.classList.add('modalOpen');
				// 若instanceList中已经有弹窗,不设置scrollTop
				if (this.instanceList.length > 0) return;
				document.body.style.top = `-${this.scrollTop}px`;
			},
			/**
			 * @description: 移除固定背景
			 * @param {}
			 * @return:viod
			 */
			// 弹层关闭之前 要做的事
			beforeClose() {
				if (!document.body.classList) {
					trackClick({
						page_title: 'ModalWrapper',
						element_name: 'beforeClose-不存在classList',
					});
				}
				if (!document.body.classList.remove) {
					trackClick({
						page_title: 'ModalWrapper',
						element_name: 'beforeClose-不存在remove方法',
					});
				}
				// 若关闭本弹窗后instanceList中还有别的弹窗, 保持页面不可滚动
				if (this.instanceList.length > 1) return;
				document.body.classList.remove('modalOpen');
				this.setScrollTop();
			},
			/**
			 * @description: 兼容scrollTop方法
			 * @param {}
			 * @return:viod
			 */
			pageScrollTop() {
				if (document.scrollingElement) {
					return document.scrollingElement.scrollTop;
				}
				return Math.max(window.pageYOffset, document.documentElement.scrollTop, document.body.scrollTop);
			},
			/**
			 * @description: 兼容赋值
			 * @param {}
			 * @return:viod
			 */
			setScrollTop() {
				if (document.scrollingElement && document.scrollingElement.scrollTop !== undefined) {
					document.scrollingElement.scrollTop = this.scrollTop;
					return;
				}
				if (document.body && document.body.scrollTop !== undefined) {
					document.body.scrollTop = this.scrollTop;
					return;
				}
				if (document.documentElement && document.documentElement.scrollTop !== undefined) {
					document.documentElement.scrollTop = this.scrollTop;
					return;
				}
			},
		},
	};
</script>

<style lang="less" scoped>
	.shade {
		background: rgba(0, 0, 0, 0.6);
		position: fixed;
		top: 0;
		right: 0;
		bottom: 0;
		left: 0;
		display: flex;
		justify-content: center;
		align-items: center;
		max-height: 100vh;
		.container {
			position: relative;
			max-height: 100vh;
			.close {
				position: absolute;
				right: 0rem;
				top: -0.36rem;
				z-index: 999;
				img {
					width: 0.24rem;
					height: 0.24rem;
				}
			}
		}
	}
	.modal-fade-enter-active,
	.modal-fade-leave-active {
		transition: all 0.4s ease;
	}
	.modal-fade-enter,
	.modal-fade-leave-to {
		transform: scale(0.2);
	}
	.modal-shade-fade-enter-active,
	.modal-shade-fade-leave-active {
		transition: all 0.4s ease;
	}
	.modal-shade-fade-enter,
	.modal-shade-fade-leave-to {
		opacity: 0;
	}
</style>



// WEBPACK FOOTER //
// src/modules/modal/ModalWrapper.vue